import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserPlus } from "lucide-react";

import { agentApi } from "@/lib/extensions-api";
import { Modal } from "@/components/ui/Modal";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";
import { toast } from "sonner";

export function AgentAssignModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const qc = useQueryClient();
  const { register, handleSubmit, reset, formState: { errors } } = useForm<{ user_id: string }>();

  const assign = useMutation({
    mutationFn: (userId: string) => agentApi.admin.assign(userId),
    onSuccess: (agent) => {
      toast.success(`${agent.full_name} is now an Agent.`);
      qc.invalidateQueries({ queryKey: ["admin-agents"] });
      reset();
      onClose();
    },
  });

  return (
    <Modal open={open} onClose={onClose} title="Assign New Agent">
      <form onSubmit={handleSubmit((v) => assign.mutate(v.user_id))} className="space-y-4">
        <div className="p-3 bg-brand-50 border border-brand-200 rounded-lg text-xs text-brand-800">
          Enter the User ID of an existing customer. They will gain Agent-role
          permissions immediately, but with zero point allocation until you load
          points for them.
        </div>
        <Input
          label="User ID"
          placeholder="USR000123"
          error={errors.user_id?.message}
          {...register("user_id", { required: "User ID is required" })}
        />
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose} type="button">Cancel</Button>
          <Button type="submit" loading={assign.isPending}
                   leftIcon={<UserPlus className="h-4 w-4" />}>
            Assign as Agent
          </Button>
        </div>
      </form>
    </Modal>
  );
}
